import { render } from "./OpenTicket.vue?vue&type=template&id=3c9c4c68"
import script from "./OpenTicket.vue?vue&type=script&lang=js"
export * from "./OpenTicket.vue?vue&type=script&lang=js"

import "./OpenTicket.vue?vue&type=style&index=0&id=3c9c4c68&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__